var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import MediaQueryWatcher, { MediaQuery } from './MediaQueryWatcher';
var mediaQueryWatcher;
export var useMediaQuery = function () {
    if (!mediaQueryWatcher) {
        mediaQueryWatcher = new MediaQueryWatcher();
    }
    var _a = __read(React.useState(mediaQueryWatcher.getMediaQuery()), 2), mediaQuery = _a[0], setMediaQuery = _a[1];
    React.useEffect(function () {
        mediaQueryWatcher.watchMediaQuery(setMediaQuery);
        return function () {
            mediaQueryWatcher.stopWatchingMediaQuery(setMediaQuery);
        };
    }, []);
    var isMobile = mediaQuery === MediaQuery.mobile;
    var isTablet = mediaQuery === MediaQuery.tablet;
    var isDesktop = mediaQuery === MediaQuery.desktop;
    var isWidescreen = mediaQuery === MediaQuery.widescreen;
    var isMobileTablet = isMobile || isTablet;
    var isTabletDesktop = isTablet || isDesktop;
    var isDesktopWidescreen = isDesktop || isWidescreen;
    return {
        mediaQuery: mediaQuery,
        isMobile: isMobile,
        isTablet: isTablet,
        isDesktop: isDesktop,
        isWidescreen: isWidescreen,
        isTabletDesktop: isTabletDesktop,
        isMobileTablet: isMobileTablet,
        isDesktopWidescreen: isDesktopWidescreen,
    };
};
